import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/pages/Dashboard';
import Motors from '@/pages/Motors';
import Profiles from '@/pages/Profiles';
import SignUp from '@/pages/SignUp';
import Login from '@/pages/Login';
import SignUpComplete from '@/pages/SignUpComplete';
import EmailSend from '@/pages/EmailSend';
import PasswordReset from '@/pages/PasswordReset';
import store from '../store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                auth: true,
            },
        },
        {
            path: '/motors',
            name: 'Motors Default',
            component: Motors,
            props: true,
            meta: {
                auth: true,
            },
        },
        {
            path: '/motors/:type',
            name: 'Motors',
            component: Motors,
            props: true,
            meta: {
                auth: true,
            },
        },
        {
            path: '/scenarios/:id',
            name: 'Existing Scenario',
            component: Profiles,
            props: true,
            meta: {
                auth: true,
            },
        },
        {
            path: '/shared/:token',
            name: 'Shared Scenario',
            component: Profiles,
            props: true,
            meta: {
                auth: true,
            },
        },
        {
            path: '/scenarios',
            name: 'new-scenario',
            component: Profiles,
            meta: {
                auth: true,
            },
        },
        {
            path: '/signup/complete',
            name: 'SignUpComplete',
            component: SignUpComplete,
            meta: {
                auth: false,
                hideSidebar: true,
                showHeader: true,
            },
        },
        {
            path: '/signup/emailsend',
            name: 'EmailSend',
            component: EmailSend,
            meta: {
                auth: false,
                hideSidebar: true,
                showHeader: true,
            },
        },
        {
            path: '/signup',
            name: 'SignUp',
            component: SignUp,
            meta: {
                auth: false,
                hideSidebar: true,
                showHeader: true,
            },
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                auth: false,
                hideSidebar: true,
                showHeader: true,
            },
        },
        {
            path: '/password-reset',
            name: 'PasswordReset',
            component: PasswordReset,
            meta: {
                auth: false,
                hideSidebar: true,
                showHeader: true,
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (!!to.meta.auth && !store.getters.isLoggedIn) {
        next({
            name: 'Login',
            query: {
                redirect: to.fullPath,
            },
        });
    } else {
        next();
    }
});

export default router;
